import { http } from '@/utils/http'

export default {
    // 图片上传
    aliOssUpload(file, publish = true, type = 'img', original, getTask) {
        return new Promise(
            async (resolve, reject) => {
                console.log('图片上传执行')
                //获取签名
                let config
                config = await this.getSignature(publish)
                let fileName = file.name
                //   // that.car_lic = car_lic
                const aliyunServerURL = publish ? config.publicHost : config.host

                // 存储路径(后台固定位置+随即数+文件格式)
                const aliyunFileKey =
                    `uploads/${type}/` + new Date().getTime() + Math.floor(Math.random() * 100) + fileName
                console.log(aliyunFileKey, '查看上传的路径')
                // 临时AccessKeyID0
                const OSSAccessKeyId = config.accessid
                // 加密策略
                const policy = config.policy
                // 签名
                const signature = config.signature
                let filePath = file.path
                // #ifdef H5
                //filePath = await this.compressImg(file);
                // #endif
                //压缩图片
                // #ifdef APP-PLUS || APP-NVUE
                console.log('aliOssUpload-file', file)

                let val = file.size //file.image.width>file.image.height?file.image.width:file.image.height
                console.log(val, '查看图片的大小')
                //if(val>5242880){  //大于5M,进行压缩
                if (!original) {
                    //默认压缩
                    filePath = await this.imgCompress(file)
                    console.log('压缩压缩压缩压缩压缩压缩')
                } else {
                    console.log('不压缩不压缩不压缩不压缩不压缩')
                }
                //}
                // #endif
                //上传oss
                var uploadTask = uni.uploadFile({
                    url: aliyunServerURL,
                    filePath: filePath, //要上传文件资源的路径
                    name: 'file', //必须填file
                    header: {},
                    formData: {
                        key: aliyunFileKey,
                        policy: policy,
                        OSSAccessKeyId: OSSAccessKeyId,
                        signature: signature,
                        success_action_status: '200',
                    },
                    success: (res) => {
                        console.log(res)
                        if (res.statusCode != 200) {
                            reject('上传错误:' + JSON.stringify(res))
                            return
                        }
                        let params = {
                            urlList: [],
                        }
                        if (publish) {
                            let domain = config.publicDomainName ? config.publicDomainName : config.publicHost
                            console.log(domain + '/' + aliyunFileKey)
                            resolve(domain + '/' + aliyunFileKey)
                            return
                        }
                        //返回图片路径 签名
                        params.urlList.push(aliyunServerURL + '/' + aliyunFileKey)
                        http
                            .post(`/api/ali/oss/signatureUrl`, params)
                            .then((res) => {
                                console.log('返回的Url', res)
                                //返回具体的图片Url
                                if (!this.isEmpty(res.result[0])) {
                                    try {
                                        let imgUrl = res.result[0].split('?')[0]
                                        console.log('获取到具体的Url', imgUrl)
                                        resolve(imgUrl)
                                    } catch (error) {
                                        resolve(res.result[0])
                                    }
                                }
                            })
                            .catch((err) => {
                                uni.hideLoading()
                                uni.showToast({
                                    title: err,
                                    duration: 3000,
                                    mask: mask,
                                })
                            })
                    },
                    fail: function (err) {
                        console.log(err)
                        reject(err)
                    },
                })
                uploadTask.onProgressUpdate((res) => {
                    /* console.log('上传进度' + res.progress);
                          console.log('已经上传的数据长度' + res.totalBytesSent);
                          console.log('预期需要上传的数据总长度' + res.totalBytesExpectedToSend); */
                    getTask(res)
                })
            },
            (err) => {
                this.toast('获取token失败')
            },
        )
    },
    //app压缩
    imgCompress(tempFilePaths) {
        /* let width = tempFilePaths.image.width>tempFilePaths.image.height?'2000':'auto'
            let height = tempFilePaths.image.width>tempFilePaths.image.height?'auto':'2000' */
        return new Promise(async (resolve, reject) => {
            uni.compressImage({
                src: tempFilePaths.path,
                /* width:tempFilePaths.image.width,
                        height:tempFilePaths.image.height, */
                success: (res) => {
                    console.log('compressImage', res)
                    uni.getImageInfo({
                        src: res.tempFilePath,
                        success: (res) => {
                            console.log('getImageInfo', res)
                        },
                    })
                    resolve(res.tempFilePath)
                },
                fail: (err) => {
                    reject(err)
                },
                complete: () => { },
            })
        })
    },
    getImageInfo(tempFilePath) {
        return new Promise(async (resolve, reject) => {
            uni.getImageInfo({
                src: tempFilePath,
                success: (res) => {
                    resolve(res)
                },
                fail: (err) => {
                    reject(null)
                },
                complete: () => { },
            })
        })
    },
    compressImg(file) {
        let resizeW = 0,
            resizeH
        return new Promise((resolve, reject) => {
            uni.getImageInfo({
                src: file.path,
                success: (res) => {
                    console.log('compressImg', res)
                    resizeW = res.width * 0.6
                    resizeH = res.height * 0.6
                    if (resizeW > 1000) {
                        resizeH = (1000 / resizeW) * resizeH
                        resizeW = 1000
                    }
                    let IMG = new Image()
                    IMG.src = file.path
                    IMG.onload = function () {
                        var canvas = document.createElement('canvas'),
                            ctx = canvas.getContext('2d')
                        canvas.width = resizeW
                        canvas.height = resizeH
                        ctx.drawImage(IMG, 0, 0, resizeW, resizeH)
                        var base64 = canvas.toDataURL('image/jpeg', 0.5)
                        resolve(base64)
                    }
                },
            })
        })
    },
    getSignature(publish) {
        return new Promise((resolve, reject) => {
            console.log('图片上传执行')
            let OssSignature = ''
            if (publish) {
                OssSignature = uni.getStorageSync('OssSignature_public')
            } else {
                OssSignature = uni.getStorageSync('OssSignature_private')
            }

            if (!this.isEmpty(OssSignature)) {
                var currentTime = Math.round(new Date().getTime() / 1000).toString() //当前时间戳
                console.log(
                    OssSignature.expire > currentTime,
                    '查看当前时间戳是否过期',
                    OssSignature.expire,
                    currentTime,
                    OssSignature.expire > currentTime,
                )
                if (OssSignature.expire > currentTime) {
                    resolve(OssSignature)
                    return
                }
            }
            http
                .get(`/api/ali/oss/getSignature`, {})
                .then((res) => {
                    if (publish) {
                        uni.setStorageSync('OssSignature_public', res.result)
                    } else {
                        uni.setStorageSync('OssSignature_private', res.result)
                    }

                    resolve(res.result)
                })
                .catch((err) => {
                    reject(err)
                    uni.hideLoading()
                    this.toast(err)
                })
        })
    },
    isEmpty(v) {
        switch (typeof v) {
            case 'undefined':
                return true
            case 'string':
                if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true
                break
            case 'boolean':
                if (!v) return true
                break
            case 'number':
                if (isNaN(v)) return true
                break
            case 'object':
                if (null === v || v.length === 0) return true
                for (var i in v) {
                    return false
                }
                return true
        }
        return false
    },
}
